import { render, staticRenderFns } from "./factura-modal-pedido.vue?vue&type=template&id=530e870e&scoped=true&"
import script from "./factura-modal-pedido.vue?vue&type=script&lang=js&"
export * from "./factura-modal-pedido.vue?vue&type=script&lang=js&"
import style0 from "./factura-modal-pedido.vue?vue&type=style&index=0&id=530e870e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e870e",
  null
  
)

export default component.exports